import axios from 'axios';
import { API_URL } from 'src/config';
import { RoofThickness } from '../types/types';

export interface IProduct {
  offer_group: string;
  type?: string;
  thickness?: RoofThickness;
  coating?: string;
  code: string;
  unit: string;
  price: number;
  purpose: string;
  sheet_width?: number | null;
  area_coeff?: number | null;
}

export const getData = async () => {
  if (API_URL) {
    return await axios
      .get(API_URL)
      .then((response) => {
        return response.data;
      })
      .catch((e) => {
        console.error(e);
      });
  } else {
    console.error('API_URL error');
  }
};

export interface IVariables {
  [key: string]: string;
}

export const getVariables = async (): Promise<IVariables | undefined> => {
  if (API_URL) {
    const baseUrl = API_URL.replace(/\/offers$/, '');
    return await axios
      .get(`${baseUrl}/variables`)
      .then((response) => response.data)
      .catch((e) => {
        console.error(e);
      });
  }
};

export interface ICity {
  id: number;
  name: string;
}

export const getCities = async (): Promise<ICity[]> => {
  if (!API_URL) {
    return [];
  }
  const baseUrl = API_URL.replace(/\/offers$/, '');
  try {
    const response = await axios.get<ICity[]>(`${baseUrl}/cities`);
    return response.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export interface IContactItem {
  name: string;
  quantity: number;
  unit?: string;
  price: number;
}

export interface IContactFormData {
  name: string;
  phone: string;
  email: string;
  city_id: number;
  comment?: string;
  consent: boolean;
  form?: string;
  files?: File[];
  items?: IContactItem[];
  total?: number;
}

export const submitContactForm = async (data: IContactFormData) => {
  const baseUrl = API_URL ? API_URL.replace(/\/offers$/, '') : '';
  if (!baseUrl) {
    throw new Error('API_URL not configured');
  }

  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('phone', data.phone);
  formData.append('email', data.email);
  formData.append('city_id', String(data.city_id));
  formData.append('comment', data.comment || '');
  formData.append('consent', data.consent ? '1' : '0');
  if (data.form) {
    formData.append('form', data.form);
  }
  if (data.files && data.files.length > 0) {
    data.files.forEach((file) => {
      formData.append('files[]', file);
    });
  }
  if (data.items && data.items.length > 0) {
    data.items.forEach((item, idx) => {
      formData.append(`items[${idx}][name]`, item.name);
      formData.append(`items[${idx}][quantity]`, String(item.quantity));
      if (item.unit) {
        formData.append(`items[${idx}][unit]`, item.unit);
      }
      formData.append(`items[${idx}][price]`, String(item.price));
    });
  }
  if (data.total !== undefined && data.total !== null) {
    formData.append('total', String(data.total));
  }

  const response = await axios.post(`${baseUrl}/contact`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
